import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import styles from './styles.module.scss'

export const AuthLayout = ({ children }) => {
  const { portalConfig, version } = useSelector((state) => state.application)
  const { backgroundUrl, logoUrl, mainColor } = portalConfig

  return (
    <div
      className={styles.authContainer}
      style={{
        backgroundImage:
          ' linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),' +
          `url(${backgroundUrl})`,
        backgroundColor: mainColor,
      }}
    >
      <div className={styles.contentContainer}>
        {logoUrl && <img src={logoUrl} alt="logo" className={styles.logo} />}
        <span className={styles.title} style={{ color: mainColor }}>
          <strong>Berichtsportal</strong>
        </span>
        <span className={styles.version}>Version: {version}</span>
        {children}
        <span className={styles.info}>
          © Copyright 2022 MSH Medien System Haus GmbH & Co. KG
        </span>
      </div>
    </div>
  )
}

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
}
